
import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LibraryHero from './components/LibraryHero';
import FeaturedTemplates from './components/FeaturedTemplates';
import LibraryGrid from './components/LibraryGrid';
import ChecklistShowcase from './components/ChecklistShowcase';
import RequestTemplate from './components/RequestTemplate';
import ScrollProgressBar from '../../components/feature/ScrollProgressBar';
import BackToTop from '../../components/feature/BackToTop';

export default function ResourcesLibraryPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mtaplannerpro.com';

  useSEO({
    title: 'Free Templates & Checklists for Tradies | MtaPlannerPro Resources Library',
    description: 'Download free professional templates, checklists, and business documents for Australian tradies. Invoice templates, safety checklists, job cards, contracts, and more.',
    keywords: 'tradie templates, trade checklists, invoice template, safety checklist, job card template, plumbing checklist, electrical certificate, HVAC service report, Australian tradies',
    canonical: `${siteUrl}/resources-library`,
    ogTitle: 'Free Templates & Checklists for Tradies | MtaPlannerPro',
    ogDescription: 'Download free professional templates, checklists, and business documents designed for Australian tradies.',
    ogUrl: `${siteUrl}/resources-library`,
    structuredData: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'CollectionPage',
          '@id': `${siteUrl}/resources-library`,
          name: 'Free Templates & Checklists for Tradies',
          description: 'Professional downloadable templates, checklists, and business documents for Australian trade businesses.',
          url: `${siteUrl}/resources-library`,
          isPartOf: {
            '@type': 'WebSite',
            '@id': `${siteUrl}/#website`,
            name: 'MtaPlannerPro',
            url: siteUrl
          }
        },
        {
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
            { '@type': 'ListItem', position: 2, name: 'Resources Library', item: `${siteUrl}/resources-library` }
          ]
        }
      ]
    }
  });

  useEffect(() => {
    const sections = document.querySelectorAll('section');
    sections.forEach((section, index) => {
      section.style.opacity = '0';
      section.style.transform = 'translate3d(0, 2rem, 0)';
      setTimeout(() => {
        section.style.transition = 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)';
        section.style.opacity = '1';
        section.style.transform = 'translate3d(0, 0, 0)';
      }, 200 + index * 100);
    });
  }, []);

  return (
    <>
      <ScrollProgressBar />
      <BackToTop />
      <div className="min-h-screen bg-slate-950">
        <Navbar />
        <LibraryHero />
        <FeaturedTemplates />
        <LibraryGrid />
        <ChecklistShowcase />
        <RequestTemplate />
        <Footer />
      </div>
    </>
  );
}
